<template>
  <BCard
    v-if="groupClassDetails"
    header-class="text-center w-100 d-block p-1"
    class="w-100"
    border-variant="success"
    header="جزئیات درآمد استاد"
    header-bg-variant="success"
    header-text-variant="white"
    align="center"
  >
    <BRow class="w-100 mt-2">
      <BCol cols="6" class="text-left">
        <p dir="ltr">:تعداد شرکت کنندگان</p>
      </BCol>
      <BCol cols="6" class="text-right">
        <p class="font-weight-bolder">
          {{ groupClassDetails.groupClassStudentsCount || 0 }} نفر
        </p>
      </BCol>

      <BCol cols="6" class="text-left">
        <p dir="rtl">درآمد استاد از هر رزرو:</p>
      </BCol>
      <BCol cols="6" class="text-right">
        <p class="font-weight-bolder">
          {{
            calculateIncomePerStudent
              ? `${Intl.NumberFormat("en-US").format(
                  calculateIncomePerStudent
                )} تومان`
              : "-"
          }}
        </p>
      </BCol>

      <BCol cols="6" class="text-left">
        <p dir="ltr">:کل درآمد استاد</p>
      </BCol>
      <BCol cols="6" class="text-right">
        <p class="font-weight-bolder">
          {{
            calculateIncomePerStudent
              ? `${Intl.NumberFormat("en-US").format(
                  calculateIncomePerStudent *
                    groupClassDetails.groupClassStudentsCount
                )} تومان`
              : "-"
          }}
        </p>
      </BCol>
    </BRow>
  </BCard>
</template>

<script>
export default {
  props: {
    groupClassDetails: {
      type: Object,
      required: true,
    },
  },
  computed: {
    calculateIncomePerStudent() {
      if (
        this.groupClassDetails &&
        this.groupClassDetails.groupClassStudents &&
        this.groupClassDetails.groupClassStudents.length &&
        this.groupClassDetails.groupClassStudents[0] &&
        !this.groupClassDetails.groupClassStudents[0].cancel &&
        this.groupClassDetails.groupClassStudents[0].masterIncome
      ) {
        return this.groupClassDetails.groupClassStudents[0].masterIncome;
      }
    },
  },
  mixins: [timeConvertUtils],
  components: {
    BRow,
    BCol,
    BCard,
  },
};
import timeConvertUtils from "@/mixins/timeConvertUtils";
import { BRow, BCol, BCard } from "bootstrap-vue";
</script>
